import { Box, Typography } from '@mui/material';
import { StepNumberWrapper, StepWrapper, TitleWrapper } from './styles';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

type StepNumberProps = {
  step: ReactNode;
};

export const StepNumber = ({ step }: StepNumberProps) => {
  return (
    <StepNumberWrapper>
      <StepWrapper color="#3859E3">{step}</StepWrapper>
    </StepNumberWrapper>
  );
};

type StepProps = {
  step: ReactNode;
  children: ReactNode;
  title: string;
  description?: string;
};

export const Step = ({ step, children, title, description }: StepProps) => {
  const { t } = useTranslation('overview');
  return (
    <Box display="flex" gap="16px" mt={1.5}>
      <Box>
        <StepNumber step={step} />
      </Box>
      <Box sx={{ width: '100%' }}>
        <Box display="flex" alignItems="center" sx={{ minHeight: '2rem' }}>
          <TitleWrapper>{t(title)}</TitleWrapper>
        </Box>
        {description && (
          <Box textAlign="left">
            <Typography
              variant="body1"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
            ></Typography>
          </Box>
        )}
        <Box mt={1.25} sx={{ paddingRight: '32px' }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};
